export enum Size {
  none = 0,
  xxxs = 10,
  xxs = 15,
  xs = 20,
  s = 30,
  m = 40,
  l = 50,
  xl = 80,
  xxl = 100,
}

export type SizeName =
  | 'none'
  | 'xxxs'
  | 'xxs'
  | 'xs'
  | 's'
  | 'm'
  | 'l'
  | 'xl'
  | 'xxl'

export const sizes = {
  none: Size.none,
  xxxs: Size.xxxs,
  xxs: Size.xxs,
  xs: Size.xs,
  s: Size.s,
  m: Size.m,
  l: Size.l,
  xl: Size.xl,
  xxl: Size.xxl,
}
